
import React, { useState } from 'react';
import { ConfigProvider, Layout } from 'antd';
import TopBar from './components/TopBar';
//import { lightTheme, darkTheme } from './themes';
import { customDefaultTheme, customDarkTheme } from './themes/customTheme'
import RouterApp from './routes';
import '../src/App.scss';
import { RefreshProvider } from './RefreshContext';

const { Content } = Layout;

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <RefreshProvider>
      <ConfigProvider theme={isDarkMode ? customDarkTheme : customDefaultTheme}>
        <RouterApp isDarkMode={isDarkMode} toggleTheme={toggleTheme}/>
        {/* <Layout style={{ minHeight: '100vh' }}>
          <TopBar isDarkMode={isDarkMode} toggleTheme={toggleTheme} />
          <Content style={{ padding: '20px' }}>
            <h1>Hello, welcome to your themed app!</h1>
          </Content>
        </Layout> */}
      </ConfigProvider>
    </RefreshProvider>
  );
}

export default App;
